import { required, minValue, helpers, minLength,email,sameAs } from '@vuelidate/validators'; 

export default class RegistrationFormViewmodel{
    constructor(){
        
        this.password = "";
        this.passwordConfirm = ""; 
        this.firstName = ""; 
        this.middleName = ""; 
        this.lastName = ""; 
        this.email = ""; 
        this.title = ""; 
        this.phone = ""; 
        this.serviceRankId = 0; 
        this.roleId = 0; 
        this.countryId = 0; 
        this.campLocationId = 0; 
        this.contractId = 0; 
        this.companyId = 0; 
        this.redeployDate = null; 
        this.certificateCommonName = null;     
    }

    GetValidationRules(_this){
        
        var rules = {
    
            formData:{
              password: {
                required, 
                minLength: helpers.withMessage("Password must be at least 15 Characters.", minLength(15)),
                upperValidator: helpers.withMessage("Password must contain at least 1 Upper Case Letter", 
                  (value) => /[A-Z]/.test(value)
                ),
                lowerValidator: helpers.withMessage("Password must contain at least 1 Lower Case Letter", 
                  (value) => /[a-z]/.test(value)
                ),
                numberValidator: helpers.withMessage("Password must contain at least 1 Number (0-9)", 
                  (value) => /[0-9]/.test(value)
                ),
                specialCharValidator: helpers.withMessage("Password must contain at least 1 Special Character Ex: #?!@$%^&*-",    
                  (value) => /[#?!@$%^&*-]/.test(value)
                ),
              },
              passwordConfirm:{
                required, 
                sameAsPassword: helpers.withMessage("Must Match Password.",sameAs(_this.password))
              },
              firstName: {required},
              lastName:{required},
              email:{required, email, emailInUse: helpers.withMessage("This email is already in use by another User account in the CAAMS system. Please try using another valid Email address and then click Register again.", value => {
                 if(_this.emailInUse) return false;
                 return true; 
              })},
              phone:{required},
              countryId: {
                minValue: helpers.withMessage("Country is Required", minValue(1))
              },
              serviceRankId:{
                minValue: helpers.withMessage("Service Rank is Required", minValue(1))
              },
              campLocationId:{
                minValue: helpers.withMessage("Camp Location is Required", minValue(1))
              },
              roleId: {
                minValue: helpers.withMessage("Role is Required", minValue(1))
              },
              contractId:{
                minValue: helpers.withMessage("Contract is Required", minValue(1))
              },
              companyId:{
                emailInUse: helpers.withMessage("Company is Required", value => {
                  if( (_this.roleId == 2 || _this.roleId == 5) && _this.companyId == 0) return false;
                  return true; 
               })},
            },
            
          }
        
          return rules; 
    }
}